import { Action } from '@ngrx/store';
import { StateUpdateFns } from 'ngrx-forms';
import {
  NgrxFormExtensionModel,
  HasNgrxForm
} from '@app/common/ngrx-forms-extensions';
import {
  TicketAddFormValue,
  TicketAddFormState
} from './ticket-add-form.model';
import { formKey } from './ticket-add-form.constant';

const formModel = new NgrxFormExtensionModel<TicketAddFormValue>(formKey);

export const getFormKey = (id: string) => formModel.getKey(id);

export const formState = (id: string) => (
  defaultValues: Partial<TicketAddFormValue> = {},
  updateFns: StateUpdateFns<TicketAddFormValue> = {}
) => ({
  [getFormKey(id)]: formModel.createFormState(
    id,
    {
      ticketTopicId: undefined,
      title: undefined,
      ticketMessage: undefined
    },
    defaultValues,
    updateFns
  )
});

export const applyFormReducer = <S extends HasNgrxForm>(
  state: S,
  action: Action,
  id: string,
  defaultSettings?: StateUpdateFns<TicketAddFormValue>
) => formModel.reduceAction(state, action, id, defaultSettings);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const markAsSubmitted = (id: string, state: any) => formModel.markAsSubmitted(id, state);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const markAsUnsubmitted = (id: string, state: any) => formModel.markAsUnsubmitted(id, state);
export const formSelector = (id: string) => formModel.selectState<TicketAddFormState>(id);
export const formValueSelector = (id: string) => formModel.selectValue(id);
export const updateGroupAction = (
  id: string,
  value: Partial<TicketAddFormValue>
) => formModel.updateGroupValue(id, value);
